/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";


type Question = {
    id:string;
    question: string;
    explanation:string;
    attachment:string;
    figure:string[];
    correctAnswerId: string;
};

export type QuizDTO = {
    id: string;
    title: string;
    duration:number;
    chapter: {
        courseId:string
    };
    lectureId:string
    QuestionEssay: Question[];
};

type GetQuizResponse = {
    statusCode?: number;
    error?: ApiError | null;
    data?: QuizDTO;
};

export const GetEssayQuizById = async (quizId: string): Promise<GetQuizResponse> => {
    try {
        const response = await axios.get(`/essay/${quizId}`);
            return { data: response.data };
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};